/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Glyphicon} from "../../GlyphIcon";
import React from "react";

export function RemoveItemButton(props) {
    const {
        show = true,
        onRemove = () => {},
        className = '',
    } = props;

    if(!show) { return null; }

    return <div className={['remove-table pop-remove', className].filter(Boolean).join(' ')}>
        <a className="pndlm-remove-control" onClick={() => onRemove()}>
            <Glyphicon glyph="remove-sign"/>
        </a>
    </div>;
}
